import TagManager from 'react-gtm-module'

/**
 * This tracks the user information via Google Tag Manager.
 *
 * @param loginData the data returned from LoginAPI.login
 */
export function trackUserViaGtm(loginData: any) {
    // ensure we don't break the UI
    loginData = typeof loginData === 'object' && loginData !== null ? loginData : {}

    const userInfo = extractUserInfo(loginData)

    TagManager.dataLayer({
        dataLayer: {
            event: 'user_login',
            user_id: userInfo.userId,
            user_name: userInfo.name,
            user_email: userInfo.email,
            user_role: userInfo.role,
            company_type: userInfo.companyType,
            ui_language: userInfo.uiLanguage,
            login_timestamp: new Date().toISOString(),
            device_type: /Mobile|Android|iPhone|iPad/.test(navigator.userAgent) ? 'mobile' : 'desktop',
        },
    })
}

function extractUserInfo(loginData: any) {
    const name = [loginData['FirstName'], loginData['LastName']].filter(v => v).join(' ')

    return {
        name: name,
        email: loginData['Email'],
        userId: loginData['UserId'],
        role: loginData['Role'],
        companyType: loginData['CompanyType'],
        uiLanguage: loginData['UiLanguage'],
    }
}
